module.exports = __webpack_public_path__ + "img/iconfont.0497628c.svg";